/**
 * this carousel is used in
 * 1. for-you page products tab
 * 2. product-category page
 */

// mui
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

// Components
import BrandCardGlideCarousel from 'components/Carousels/core/BrandCardGlideCarousel';
import ProductCardGlideCarousel from 'components/Carousels/core/ProductCardGlideCarousel';
import ProductCarouselsSkeleton from 'components/Carousels/skeleton/ProductCarouselsSkeleton';

// utils
import { Root } from 'utils/types';
import { productCarouselSettings } from 'utils/carousels';

const Title = ({ title }: { title: string }) => {
  return (
    <Typography variant="h6" fontWeight="700">
      {title}
    </Typography>
  );
};

type RecentBrowsedProductsRendererProps = {
  data: Root;
  isLoading: boolean;
  type: string;
  page?: string;
  sx?: {};
  carouselSettings: any;
  viewAllRef: string;
  isAuthenticated?: boolean;
};

const RecentBrowsedProductsRenderer = ({
  data,
  isLoading,
  type = 'products',
  carouselSettings = productCarouselSettings,
  viewAllRef,
  sx,
  page = '',
  isAuthenticated = false,
}: RecentBrowsedProductsRendererProps) => {
  const { products = [], brands = [] } = data || {};

  if (type === 'products' && !products.length) return null;
  if (type === 'brands' && (!brands || brands.length < 4)) return null;

  const carousel =
    type === 'products' ? (
      <ProductCardGlideCarousel
        sx={{ mt: page === 'cart' ? 1 : 2, ...sx }}
        products={products}
        isLoading={isLoading}
        title={(<Title title="Recently viewed products" />) as unknown as string}
        viewAllUrl={`/recent-products?tab=products&ref=${viewAllRef}`}
        carouselSettings={carouselSettings}
        page={page}
      />
    ) : (
      <BrandCardGlideCarousel
        sx={{ mt: page === 'cart' ? 1 : 2, ...sx }}
        brands={brands}
        isLoading={isLoading}
        title={<Title title="Brands of Recently Viewed Products" />}
        viewMoreUrl={`/recent-products?ref=${viewAllRef}`}
        carouselSettings={carouselSettings}
        showMoreUrl={false}
      />
    );

  return isLoading ? (
    <ProductCarouselsSkeleton page={page} isAuthenticated={isAuthenticated} />
  ) : (
    <Container maxWidth="xl" sx={{ mb: 2, px: { xs: 0, sm: 3 } }}>
      {carousel}
    </Container>
  );
};

export default RecentBrowsedProductsRenderer;
